import React from 'react';
import PropTypes from 'prop-types';
import VideoCard from './VideoCard.js';

/**
 * VideoGrid component for displaying a grid of video thumbnails
 * @param {Object} props - Component props
 * @param {Array} props.videos - Array of video objects
 * @param {Function} props.onVideoClick - Function to handle video selection
 */
const resolveVideoKey = (video, index) => {
  if (video?.id) {
    if (typeof video.id === 'string') {
      return video.id;
    }
    if (typeof video.id === 'object') {
      return video.id.videoId || video.id.id || `video-${index}`;
    }
  }
  return `video-${index}`;
};

const VideoGrid = ({ videos, onVideoClick }) => {
  return (
    <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-4">
      {videos.map((video, index) => (
        <VideoCard key={resolveVideoKey(video, index)} video={video} onClick={onVideoClick} />
      ))}
    </div>
  );
};

VideoGrid.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.object).isRequired,
  onVideoClick: PropTypes.func.isRequired,
};

// ⚡ Bolt: Wrapped VideoGrid in React.memo to prevent unnecessary re-renders
// when parent component (Home) state updates but props remain the same.
export default React.memo(VideoGrid);
